import React from 'react';
import { Box, Heading, Radio, RadioGroup, Text } from '@razorpay/blade/components';
import { useFormWithProvider } from 'forms';

import type { AttendanceSettingsFormState } from 'components/Settings/AttendanceAndLeavesSettings/types';

export const LeaveCalendarYear = () => {
  const { formData, setFieldValue } = useFormWithProvider<AttendanceSettingsFormState>();

  const value = formData.useFinancialYear ? 'financial' : 'calendar';

  return (
    <Box
      padding="spacing.6"
      borderRadius="medium"
      borderWidth="thin"
      borderColor="surface.border.gray.subtle"
      backgroundColor="surface.background.gray.intense">
      <Heading size="medium">Leave calendar year</Heading>
      <Text marginTop="spacing.2" size="medium" color="surface.text.gray.muted">
        All accruals, carry-forwards and resets follow this calendar.
      </Text>

      <RadioGroup
        label=""
        value={value}
        onChange={({ value: next }) => setFieldValue('useFinancialYear', next === 'financial')}
        marginTop="spacing.7">
        <Box display="flex" flexDirection="row" gap="spacing.10">
          <Radio
            value="financial"
            helpText="Resets on 1 April. Aligns with statutory tax and compliance cycles.">
            Financial year (Apr – Mar)
          </Radio>
          <Radio value="calendar" helpText="Resets on 1 January.">
            Calendar year (Jan – Dec)
          </Radio>
        </Box>
      </RadioGroup>
    </Box>
  );
};
